import { Instagram, MessageCircle, Twitter } from 'lucide-react';

const SocialMedia = () => {
  return (
    <div className="mb-16">
      <div className="text-center">
        <h3 className="text-2xl font-bold mb-3 bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">Follow Us</h3>
        <p className="text-gray-400 mb-6">Sign-up for exclusive updates and offers</p>
        <div className="flex justify-center gap-4">
          {/* Instagram */}
          <button
            className="p-3 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full hover:scale-110 transition-all duration-300 shadow-lg hover:shadow-pink-500/30"
          >
            <Instagram size={20} className="text-white" />
          </button>

          {/* Telegram */}
          <button
            className="p-3 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full hover:scale-110 transition-all duration-300 shadow-lg hover:shadow-blue-500/30"
          >
            <MessageCircle size={20} className="text-white" />
          </button>

          {/* X (Twitter) */}
          <button
            className="p-3 bg-gradient-to-r from-gray-700 to-gray-800 rounded-full hover:scale-110 transition-all duration-300 shadow-lg hover:shadow-gray-300/30"
          >
            <Twitter size={20} className="text-white" />
          </button>

          {/* Discord */}
          <button
            className="p-3 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full hover:scale-110 transition-all duration-300 shadow-lg hover:shadow-indigo-500/30"
          >
            <MessageCircle size={20} className="text-white" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SocialMedia;
